import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { useAuth } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { authenticateCreate } from '@/services/auth.service'
import { storage } from '@/utils/session'
import {
  EDU_ACCESS_TOKEN_STORAGE_NAME,
  EDU_REFRESH_TOKEN_STORAGE_NAME,
} from '@/const'
import { useSubmit } from './FormMixin'


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-form',
  setup(__props, { expose: __expose }) {
  __expose();

const username = ref("")
const password = ref("")

const router = useRouter()

const store = useAuth()

const request = async (sendData, control) => {
  const error = (await useSubmit(send(sendData), control, true))
}

const send = async data => {
  const sendData = {
    ...data
  }
  try { 
    const { access, refresh } = (await authenticateCreate.execute({}, {
        ...sendData,
      }))
    storage.setItem(EDU_ACCESS_TOKEN_STORAGE_NAME, access)
    storage.setItem(EDU_REFRESH_TOKEN_STORAGE_NAME, refresh)
    // await store.getUser(router, access) 
    store.saveToken(access, refresh)

    window.location.href = '/'
  } catch (e) {
    return Promise.reject(e)
  }
}



const __returned__ = { username, password, router, store, request, send, ref, get useAuth() { return useAuth }, get useRouter() { return useRouter }, get authenticateCreate() { return authenticateCreate }, get storage() { return storage }, get EDU_ACCESS_TOKEN_STORAGE_NAME() { return EDU_ACCESS_TOKEN_STORAGE_NAME }, get EDU_REFRESH_TOKEN_STORAGE_NAME() { return EDU_REFRESH_TOKEN_STORAGE_NAME }, get useSubmit() { return useSubmit } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})